import PropTypes from 'prop-types';
import React from 'react';

import * as S from './Avatar.styles';

export const AvatarSize = {
  LARGE: 'large',
  REGULAR: 'regular',
  SMALL: 'small',
};

export const Avatar = ({ altText, imageUrl, size }) => {
  if (!imageUrl) {
    return null;
  }

  return (
    <S.StyledContainer size={size}>
      <S.StyledImage alt={altText} src={imageUrl} />
    </S.StyledContainer>
  );
};

Avatar.propTypes = {
  /**
   * Set an alt-text to the image.
   */
  altText: PropTypes.string,
  /**
   * Image url, any size.
   */
  imageUrl: PropTypes.string.isRequired,
  /**
   * Avatar size.
   */
  size: PropTypes.oneOf(Object.values(AvatarSize)),
};

Avatar.defaultProps = {
  altText: 'avatar',
  size: AvatarSize.REGULAR,
};
